module.exports = __webpack_public_path__ + "static/media/earth.f6bd2360.png";